module.exports = __webpack_public_path__ + "static/media/128-fit.882f3da2.svg";